const UNITS = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

/** `15728640` → `15MB`, `1536` → `1.5kB`. The unit carries no space and no translation. */
export const formatBytes = (bytes: number): string => {
  let unit = 0;
  let n = bytes;

  while (n >= 1024) {
    n /= 1024;
    unit += 1;
  }

  return `${n.toFixed(n >= 10 || unit < 1 ? 0 : 1)}${UNITS[unit]}`;
};

export const formatDuration = (seconds: number): string => {
  const date = new Date(0);
  date.setSeconds(seconds);
  const dateString = date.toISOString().slice(11, 19);
  if (seconds < 3600) return dateString.slice(3);
  return dateString;
};
